
export const CODE_MASTER = Object.freeze({
    /* 管理者区分
     * AUTHORITY_SYSTEM_ADMIN システム管理者
     * AUTHORITY_GOLFCOUSE_ADMIN ゴルフ場担当者
     * AUTHORITY_SYSTEM_ADMIN_GOLF_CODE システム管理者ゴルフコード  */
    AUTHORITY_SYSTEM_ADMIN: '1',
    AUTHORITY_GOLFCOUSE_ADMIN: '10',
    AUTHORITY_SYSTEM_ADMIN_GOLF_CODE: '0000000000',
    /* ポイントフラグ
     * POINTFLAG_NOLIMIT 期限なし
     * POINTFLAG_NORMAL 通常
     * POINTFLAG_LIMIT 期間限定 */
    POINTFLAG_NOLIMIT: '1',
    POINTFLAG_NORMAL: '2',
    POINTFLAG_LIMIT: '3',
    /* テンプレート
     * TEMPLATE_TERMS_SERVICE 利用規約
     * TEMPLATE_TEMPORARY_MEMBER_REGIST_MAIL 仮会員登録メール
     * TEMPLATE_MEMBER_REGIST_COMPLETE_MAIL 会員登録完了メール
     * TEMPLATE_MEMBER_INFO_CHANGE_ACCEPTANCE_MAIL 会員情報変更受付メール
     * TEMPLATE_MEMBER_INFO_CHANGE_COMPLETE_MAIL 会員情報変更完了メール
     * TEMPLATE_MEMBER_PASS_RESETTING_ACCEPTANCE_MAIL パスワード再設定受付メール
     * TEMPLATE_MEMBER_PASS_RESETTING_COMPLETE_MAIL パスワード再設定完了メール
     * TEMPLATE_MEMBER_PASS_CHANGE_COMPLETE_MAIL パスワード変更完了メール
     * TEMPLATE_MEMBER_EXIT_COMPLETE_MAIL 退会完了メール
     * TEMPLATE_CANCEL_SENTENCE キャンセル固定文
     * TEMPLATE_PLAN_DETAILED_SENTENCE プラン詳細固定文 */
    TEMPLATE_TERMS_SERVICE: '1',
    TEMPLATE_TEMPORARY_MEMBER_REGIST_MAIL: '2',
    TEMPLATE_MEMBER_REGIST_COMPLETE_MAIL: '3',
    TEMPLATE_MEMBER_INFO_CHANGE_ACCEPTANCE_MAIL: '4',
    TEMPLATE_MEMBER_INFO_CHANGE_COMPLETE_MAIL: '5',
    TEMPLATE_MEMBER_PASS_RESETTING_ACCEPTANCE_MAIL: '6',
    TEMPLATE_MEMBER_PASS_RESETTING_COMPLETE_MAIL: '7',
    TEMPLATE_MEMBER_PASS_CHANGE_COMPLETE_MAIL: '8',
    TEMPLATE_MEMBER_EXIT_COMPLETE_MAIL: '9',
    TEMPLATE_CANCEL_SENTENCE: '10',
    TEMPLATE_PLAN_DETAILED_SENTENCE: '11',
    /* ポイント利用タイプ
     * POINT_USE_TYPE_GROUP グループ毎
     * POINT_USE_TYPE_GOLF ゴルフ場毎 */
    POINT_USE_TYPE_GROUP: '1',
    POINT_USE_TYPE_GOLF: '2',
    /* 期間限定ポイント利用区分
     * LIMITPOINT_STATUS_CASE 利用分
     * LIMITPOINT_STATUS_ALL 全て */
    LIMITPOINT_STATUS_CASE: '1',
    LIMITPOINT_STATUS_ALL: '2',
    /* WEB会員ステータス
     * MEMBER_STATUS_WEB WEB会員
     * MEMBER_STATUS_POINT ポイント会員
     * MEMBER_STATUS_DEFAULT ログイン画面のパラメータudの初期値
     * (1:ポイント会員、2:WEB会員)*/
    MEMBER_STATUS_WEB: '0',
    MEMBER_STATUS_POINT: '1',
    MEMBER_STATUS_DEFAULT: '2',
    /* 会員区分
     * MEMBER_CLASS_VISITOR ビジター
     * MEMBER_CLASS_ANNUAL 年次会員
     * MEMBER_CLASS_NORMAL 会員 */
    MEMBER_CLASS_VISITOR: '0',
    MEMBER_CLASS_ANNUAL: '1',
    MEMBER_CLASS_NORMAL: '2',
    /* 予約状況
     * RESERVE_SITUATION_NOW 予約
     * RESERVE_SITUATION_USED 来場済み
     * RESERVE_SITUATION_CANCEL キャンセル */
    RESERVE_SITUATION_NOW: '1',
    RESERVE_SITUATION_USED: '2',
    RESERVE_SITUATION_CANCEL: '3',
    /* 予約タイプ
     * RESERVE_TYPE_NORMAL 通常予約
     * RESERVE_TYPE_SHARE 通常（シェア）予約
     * RESERVE_TYPE_REQUEST リクエスト予約 */
    RESERVE_TYPE_NORMAL: '1',
    RESERVE_TYPE_SHARE: '2',
    RESERVE_TYPE_REQUEST: '3',
    /* ラウンドタイプ
     * ROUND_TYPE_9H 9ホール
     * ROUND_TYPE_1R 1ラウンド
     * ROUND_TYPE_1_5R 1.5ラウンド
     * ROUND_TYPE_2R 2ラウンド
     * ROUND_TYPE_UNLIMITED 回り放題 */
    ROUND_TYPE_9H: '1',
    ROUND_TYPE_1R: '2',
    ROUND_TYPE_1_5R: '3',
    ROUND_TYPE_2R: '4',
    ROUND_TYPE_UNLIMITED: '9',
    /* 税区分
     * TAX_DIVISION_PASENTO ％
     * TAX_DIVISION_CIRCLE 円 */
    TAX_DIVISION_PERCENT: '1',
    TAX_DIVISION_CIRCLE: '2',
    /* 税種別
     * TAX_TYPE_CONSUMPTION 消費税
     * TAX_TYPE_USAGE 利用税
     * TAX_TYPE_ANOTHER その他諸経費 */
    TAX_TYPE_CONSUMPTION: '1',
    TAX_TYPE_USAGE: '2',
    TAX_TYPE_ANOTHER: '3',
    /* プレースタイル・システム設定値
     * NOT_USE_SETTING 機能なし
     * DEFAULT_USE_SETTING 機能あり */
    NOT_USE_SETTING: 9,
    DEFAULT_USE_SETTING: 0,
    /* 食事フラグ
     * MEAL_YES 食事つき
     * MEAL_NO 食事なし */
    MEAL_YES: '0',
    MEAL_NO: '1',
    /* キャディーフラグ
     * CADDIE_YES キャディー付き
     * CADDIE_NO キャディーなし */
    CADDIE_YES: '0',
    CADDIE_NO: '1',
    /* 宿泊フラグ
     * ACCOMMODATION_YES 宿泊付き
     * ACCOMMODATION_NO 宿泊無し */
    ACCOMMODATION_YES: '0',
    ACCOMMODATION_NO: '1',
    /* サム保証
     * GUARANTEE_NO サム保証なし
     * GUARANTEE_2B 2B保証
     * GUARANTEE_3B 3B保障 */
    GUARANTEE_NO: '1',
    GUARANTEE_2B: '2',
    GUARANTEE_3B: '3',
    /* カートコード
     * CART_AUTO2 2人乗り乗用
     * CART_AUTO4 4-5人乗り乗用
     * CART_AUTO 電動
     * CART_MANUAL 手引き */
    CART_AUTO2: '1',
    CART_AUTO4: '2',
    CART_AUTO: '3',
    CART_MANUAL: '4',
    /* 曜日指定タイプ
     * DATE_TYPE_FIXED_DATE 日付固定
     * DATE_TYPE_TARGET_DATE 対象日指定 */
    DATE_TYPE_FIXED_DATE: '1',
    DATE_TYPE_TARGET_DATE: '2',
    /* 来場コード */
    VISITED_CODE_RESERVE: '0',    // 予約中
    VISITED_CODE_VISITORS: '1',   // 来場済み
    VISITED_CODE_CANCEL: '2',     // キャンセル
    /* 予約ステータス */
    RESERVE_STATUS_WEB_RESERVED: '0', // WEB予約済み
    RESERVE_STATUS_POSSIBLE: '1', // 予約可能
    RESERVE_STATUS_SHARE_POSSIBLE: '2', // シェア予約可能
    RESERVE_STATUS_OTHER_RESERVED: '3', // 他サイトで予約済
    RESERVE_STATUS_DELETED: '9', // 枠削除
    /**
     *  土日祝日タイプ
     */
    DAY_SATURDAY : '1', // 土曜日
    DAY_HOLIDAY  : '2'  // 日曜祝日
});
